/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import {
  Grid,
  CircularProgress,
  Alert, 
  AlertTitle,
  TextField,
  Select,
  Tab,
  Tabs,
  Paper,
  MenuItem,
} from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { respPriorityQueueSum, PriorityQueueSum, getPriorityQueueSum } from "../../utils/GetAdmin";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import {
  Lock,
} from '@mui/icons-material';
import {formatDate, formatDateTime, getUniqueStringList} from "../../utils/Formatter";
import chartjs, { Line, ChartData } from "react-chartjs-2";


const chartColorScheme = [
  "#25CCF7","#FD7272","#54a0ff","#e67e22","#27ae60","#d63031","#2ecc71","#9b59b6","#16a085","#00d2d3",
  "#2980b9","#8e44ad","#f1c40f","#1abc9c","#e74c3c","#f39c12","#d35400","#3498db","#c0392b","#55efc4",
  "#81ecec","#74b9ff","#a29bfe","#dfe6e9","#00b894","#00cec9","#0984e3","#6c5ce7","#ffeaa7","#fab1a0",
  "#ff7675","#fd79a8","#fdcb6e","#e17055","#feca57","#5f27cd","#54a0ff","#01a3a4"
];
function getColor(i:number){
  return chartColorScheme[i % chartColorScheme.length];
}

type Metric = 'insert_rc'|'start_rc'|'end_rc'|'open_rc';
function Metric(s:any): Metric{
  return s
}
type SumDataRow = {
  bucket_dt:string,
  queue_name:string,
  insert_rc:number,
  start_rc:number,
  end_rc:number,
  open_rc:number
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      margin: '0',
      position: 'absolute',
      top: '50%',
      left: '50%',
    },
    controlBar: {
    },
    root: {
      margin: '0',
      padding:'0',

    },
    divWidth: {
      width: "100%"
    },
    gridSpaceable: {
      padding: theme.spacing(2)
    },
    gridMarginTop: {
      marginTop: theme.spacing(2)
    },
    paragraph: {
      padding: theme.spacing(1)
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #000',
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2)
    },
    navtab: {
      backgroundColor: theme.palette.grey[100],
    },
    navtabsel: {
      backgroundColor: theme.palette.grey[400],
    },
    primary: {
      marginTop: theme.spacing(2)
    },
    button: {
      marginLeft: theme.spacing(2),
      minWidth: 150
    }
  }));
export default function ISupPrioQueue() {
  const classes = useStyles();
  const [priorityQueueSum, setPriorityQueueSum] = useState<respPriorityQueueSum|undefined>();
  const [startDt,setStartDt] = React.useState<Date>(new Date(Date.now() - 86400000));
  const [endDt,setEndDt] = React.useState<Date>(new Date());
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId,salesOrg,'security_admin');
  const [codes, setCodes] = React.useState<any>();
  const [graphMetric, setGraphMetric] = React.useState<Metric>('open_rc');
  
  const header =  document.querySelector('ResponsiveDrawer')
  const headerAdj = header?header.clientHeight:150;
  const controlAdj = 55;
  const [TABLE_BODY_HEIGHT, setTABLE_BODY_HEIGHT] = React.useState<string>(`${window.innerHeight - headerAdj - controlAdj }px`);
  window.addEventListener('resize', ()=>{
    setTABLE_BODY_HEIGHT(`${window.innerHeight - headerAdj }px`);
  })

  
  const [curTab, setCurTab] = React.useState<number>(0);
  
            
  const subtabs = [
    {
      title: "Table",
      content: <ISupPrioQueueTable tableBodyHeight={TABLE_BODY_HEIGHT} pQSumData={priorityQueueSum} />
    },
    {
      title: "Graph",
      content: <ISupPrioQueueChart graphMetric={graphMetric} pQSumData={priorityQueueSum}  />
    }
  ];

  const handleTabsChange = (_: React.ChangeEvent<{}>, value: any) => {
    const idx = subtabs?.findIndex((v: any) => v.title === value) || 0;
    setCurTab(idx);
  };
  const handleDateChange = () => {
    setPriorityQueueSum(undefined);
    setDoneLoading(false);
  };
  
  useEffect(() => {
    if (doneLoading) return;

    getPriorityQueueSum(salesOrg,formatDate(startDt),formatDate(endDt)).then((v) => {
      setDoneLoading(true);
      if(v){
        setPriorityQueueSum(v);
      }
    });
      
  }, [priorityQueueSum, doneLoading, salesOrg, startDt, endDt, graphMetric ]);
  
  
  return (
    <div>
      {enabled ? (
        <div className={classes.root}>
          <Paper className={classes.root}>
             
            <Grid container spacing={2} className={classes.primary}> 
              <Grid item xs={12} xl={6}>
                <Tabs
                  className={classes.navtab}
                  onChange={handleTabsChange}
                  value={subtabs[curTab].title}
                  variant="fullWidth"
                >
                  {subtabs.map((tab,i) =>
                        (<Tab
                            className={(i==curTab)?classes.navtabsel:classes.navtab}
                            key={tab.title}
                            label={tab.title}
                            value={tab.title}
                        />))}
                </Tabs>
              </Grid>
              <Grid item xs={12} xl={6}>
                <div className={classes.controlBar}>
                  
                  <Grid container spacing={2} className={classes.primary}> 
                    
                    <LocalizationProvider  dateAdapter={AdapterDateFns}>
                      <Grid item xs={4} xl={4}>
                        <DatePicker 
                          label="Start Date"
                          value={startDt}
                          onChange={(val) => {if(val && val != startDt){setStartDt(val);handleDateChange();}}}
                          renderInput={(props:any) => (
                            <TextField {...props} variant="outlined" label={`Start Date`}  />
                            )}
                        />
                      </Grid>
                      <Grid item xs={4} xl={4}>
                        <DatePicker 
                          label="End Date"
                          value={endDt}
                          onChange={(val) => {if(val && val != endDt){setEndDt(val);handleDateChange();}}}
                          renderInput={(props:any) => (
                            <TextField {...props} variant="outlined" label={`End Date`}  />
                            )}
                        />
                      </Grid>
                    </LocalizationProvider >
                    <Grid item xs={4} xl={4}>
                      <Select
                        label="Chart Metric"
                        required
                        placeholder="Delivery Plant"
                        value={graphMetric}
                        inputProps={{ name: "Delivery Plant" }}
                        onChange={(e) => {
                          setGraphMetric(Metric(e.target.value));
                        }}
                      >
                        <MenuItem key="insert_rc" value="insert_rc">
                          Queue Insert
                        </MenuItem>
                        <MenuItem key="start_rc" value="start_rc">
                          Proccessing Started
                        </MenuItem>
                        <MenuItem key="end_rc" value="end_rc">
                          Proccessing Complete
                        </MenuItem>
                        <MenuItem key="open_rc" value="open_rc">
                          Open Queue Tasks
                        </MenuItem>
                      </Select>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </Grid>
            {subtabs[curTab].content}
          </Paper>
        </div>
      ) : (
        <Alert severity="error">
          <AlertTitle><Lock/> Access Error</AlertTitle>   
          You do not currently have access to <strong>CONA Internal Support</strong> 
          activities for the <strong>{salesOrg}</strong> bottler. 
        </Alert>
      )}
    </div>
   )
}

function LoadingSpinner(){
  return (<CircularProgress />)
}


function lineChartDataMap(
  color:string,
  queueName:string,
  metric:Metric,
  sumData: SumDataRow[])
  {
    const data:ChartData<any> = {
      backgroundColor:color,
      borderColor:color,
      borderWidth:1,
      fill:false,
      fillColor:color,
      highlightFill:color,
      highlightStroke:color,
      strokeColor:color,
      lineTension:0,

      label:queueName,
      data:sumData.filter(q=>q.queue_name == queueName).map(m=> {return {x:m.bucket_dt,y:m[metric]}}),
    }

    return data;
}


function ISupPrioQueueChart(props: {graphMetric:Metric, pQSumData: respPriorityQueueSum | undefined}) {
  if (props.pQSumData === undefined){
    return (<LoadingSpinner/>)
  }
  const metric = props.graphMetric
  const sumData: SumDataRow[] = props.pQSumData.priorityQueueSum.map(q=>{
    return {
      bucket_dt:q.bucket_dt,
      queue_name:q.queue_name,
      insert_rc:q.insert_rc,
      start_rc:q.start_rc,
      end_rc:q.end_rc,
      open_rc:q.open_rc,
    }
  });


  let sumTotal: SumDataRow[] = [] 
  sumData.forEach(q => {
    let c = sumTotal.find(s=>s.bucket_dt == q.bucket_dt)
    if(c){
      c.insert_rc += q.insert_rc
      c.start_rc += q.start_rc
      c.end_rc += q.end_rc
      c.open_rc += q.open_rc
    } else {
      sumTotal.push({
        bucket_dt:q.bucket_dt,
        queue_name:'Total',
        insert_rc:q.insert_rc,
        start_rc:q.start_rc,
        end_rc:q.end_rc,
        open_rc:q.open_rc,
      })
    }
  });

  const queues = getUniqueStringList(sumData.map(q=>q.queue_name))
  const buckets = getUniqueStringList(sumData.map(q=>q.bucket_dt)).sort();

  const data = queues.map((q,i)=>{
    const color = getColor(i)
    return lineChartDataMap(color,q,metric,sumData);
  }).concat(
    lineChartDataMap('black','total',metric,sumTotal)
  )

  const options={
    type:'Line',
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            gridLines: {
              display:false,
              drawOnChartArea: false
            },
            ticks: {
              beginAtZero: true
            }
          }
        ],
        /* This logic included for showing multiple x-Axes */
        xAxes:[{
          position: 'bottom',
          gridLines: {
            display:false,
            drawOnChartArea: false 
          },
          ticks: {
            callback(value:any):any {
              return value.split(';')[0];
            }
          }
        },
          {
            gridLines: {
              display:false,
              drawOnChartArea: false 
            },
            position: 'bottom',
            ticks: {
              callback(value:any):any {
                return value.split(';')[1];
              }
            }
          }
      ]
    },
      legend: {
        position: "bottom"
      },
      animation: false,
      tooltips: {
        callbacks: {
          label (tooltipItem: any, data: any) {
            return `${data.datasets[tooltipItem.datasetIndex].label}: ${
              tooltipItem.value
            } Units`;
          }
        }
      },
   annotation: {
        autoColors: false,
        annotations: [
    {
      //       // Indicates the type of annotation
           type: "box",
          xMin: "01/12/2021",
           xMax: "04/14/2021",
          yMin: 0,
           yMax: 0,
          backgroundColor: "rgba(255, 99, 132, 1.0)"
          }
        ]
       }
  }

  return (
    //<Line data={data} options={options} />
    <div/>
  )
}

function ISupPrioQueueTable(props: {tableBodyHeight:string, pQSumData: respPriorityQueueSum | undefined }) {
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  if (props.pQSumData === undefined){
    return (<LoadingSpinner/>)
  }
  return (
    <TableAbstraction
        settingsKey="ADM_IS_PQ_MON"
        options={{
          draggableColumns: {
            enabled: true
          },
          rowsPerPageOptions: [25, 50, 100],
          tableBodyHeight:props.tableBodyHeight,
          serverSide: false,
          selectableRows: "none",
          rowsPerPage: muiTable.rpp,
          onChangeRowsPerPage: (numberOfRows) => {
            muiTable.rpp = numberOfRows;
            setMuiTable(muiTable);
          }
        }}
        title={'Priority Queue Summary'}
        columns={[
          {
            label: "Date Bucket",
            name: "bucket_dt",
            options: {
              searchable: false,
              filter: true,
              customBodyRender: (value)=> {return value?formatDateTime(value):''}
            }
          },
          {
            label: "Queue",
            name: "queue_name",
            options: {
              searchable: false,
              filter: true
            }
          },
          {
            label: "New RC",
            name: "insert_rc",
            options: {
              searchable: false,
              filter: true
            }
          },
          {
            label: "Start RC",
            name: "start_rc",
            options: {
              searchable: false,
              filter: true
            }
          },
          {
            label: "Complete RC",
            name: "end_rc",
            options: {
              searchable: false,
              filter: true
            }
          },
          {
            label: "Open RC",
            name: "open_rc",
            options: {
              searchable: false,
              filter: true
            }
          },
          {
            label: "Oldest Open",
            name: "oldest_open",
            options: {
              searchable: false,
              filter: true,
              customBodyRender: (value)=> {return value?formatDateTime(value):''}
            }
          },
          {
            label: "Newest Open",
            name: "newest_open",
            options: {
              searchable: false,
              filter: true,
              customBodyRender: (value)=> {return value?formatDateTime(value):''}
            }
          },
          {
            label: "Num Batches",
            name: "batch_count",
            options: {
              searchable: false,
              filter: true
            }
          },
          {
            label: "Total RC",
            name: "record_count",
            options: {
              searchable: false,
              filter: true
            }
          },
          {
            label: "Total MS",
            name: "total_ms",
            options: {
              searchable: false,
              filter: true
            }
          },
          {
            label: "Total Run Time",
            name: "total_run_time",
            options: {
              searchable: false,
              filter: true,
              customBodyRender: (value)=> {return value?formatDateTime(value,'hms'):''}
            }
          },
          {
            label: "Max Run MS",
            name: "max_ms_run",
            options: {
              searchable: false,
              filter: true
            }
          },
          {
            label: "Min Run MS",
            name: "min_ms_run",
            options: {
              searchable: false,
              filter: true
            }
          },
          {
            label: "AVG Run MS",
            name: "avg_ms_run",
            options: {
              searchable: false,
              filter: true
            }
          },
          {
            label: "Max MS Per",
            name: "max_ms_run_per",
            options: {
              searchable: false,
              filter: true
            }
          },
          {
            label: "Min MS Per",
            name: "min_ms_run_per",
            options: {
              searchable: false,
              filter: true
            }
          },
          {
            label: "AVG MS Per",
            name: "avg_ms_run_per",
            options: {
              searchable: false,
              filter: true
            }
          }
        ]}
        data={props.pQSumData.priorityQueueSum.filter(q=>{return q.start_rc || q.insert_rc || q.end_rc})}
      />
  )

}
